import { Metric } from '../../../../dashboard-config/dashboard-config.model';
import {
  expandProductCatalog,
  ProductCatalogEntry,
} from '../../../_shared/dashboard-definition.model';
import { createDashboardComparisonIndustriesDefinition } from './create-dashboard-comparison-industries-definition';
import {
  ComparisonIndustriesMetricProfile,
  comparisonIndustriesCompaniesCountProfile,
  comparisonIndustriesCompaniesRevenueProfile,
  comparisonIndustriesEconomicParticipantProfile,
  comparisonIndustriesEmployedProfile,
  comparisonIndustriesGvaProfile,
} from './dashboard-comparison-industries-metric.profile';
import { DashboardComparisonIndustriesShell } from './dashboard-comparison-industries-shell.profile';
import { DashboardComparisonIndustriesDefinition } from './dashboard-comparison-industries.definition';

/**
 * Product catalog for national comparison industries dashboards.
 * Shell/metric profiles own behavior; this file owns which products exist.
 * Identity is derived in {@link createDashboardComparisonIndustriesDefinition}.
 */

type ComparisonIndustriesMetric = Exclude<
  Metric,
  Metric.Tourism | Metric.SelfEmployed
>;

export const COMPARISON_INDUSTRIES_PRODUCT_CATALOG: Record<
  ComparisonIndustriesMetric,
  ProductCatalogEntry<
    ComparisonIndustriesMetricProfile,
    DashboardComparisonIndustriesShell
  >
> = {
  [Metric.CompaniesCount]: {
    metric: comparisonIndustriesCompaniesCountProfile,
    shells: ['industries'],
  },
  [Metric.CompaniesRevenue]: {
    metric: comparisonIndustriesCompaniesRevenueProfile,
    shells: ['industries'],
  },
  [Metric.GrossValueAdded]: {
    metric: comparisonIndustriesGvaProfile,
    shells: ['industries'],
  },
  [Metric.EconomicParticipant]: {
    metric: comparisonIndustriesEconomicParticipantProfile,
    shells: ['industries'],
  },
  [Metric.Employed]: {
    metric: comparisonIndustriesEmployedProfile,
    shells: ['industries'],
  },
};

/** All national comparison industries product definitions. */
export const COMPARISON_INDUSTRIES_DEFINITIONS: DashboardComparisonIndustriesDefinition[] =
  expandProductCatalog(
    Object.values(COMPARISON_INDUSTRIES_PRODUCT_CATALOG),
    createDashboardComparisonIndustriesDefinition,
  );
